export default __webpack_public_path__ + "4f3b4adb55792f212d6ee1ce2b5c3933.svg";